import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'
import * as Sentry from '@sentry/react'
import { LoadingSpinner } from '../../components'
import Header from '../TeamsDashboard/components/Header'
import ErrorMessage from '../../components/ErrorMessage'
import ClubSubscriptionsContainer from './components/ClubSubscriptionsContainer'
import { fetchAuthenticatedUser, fetchClub } from './api'

const ClubSubscriptionPage = ({
  match: {
    params: { clubUuid },
  },
}) => {
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)
  const [userCurrency, setUserCurrency] = useState(null)
  const [club, setClub] = useState(null)
  const [theme, setTheme] = useState({})

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true)

      try {
        const [userResponse, clubResponse] = await Promise.all([
          fetchAuthenticatedUser(),
          fetchClub(clubUuid),
        ]);

        // eslint-disable-next-line camelcase
        const { data: { stripe_currency } } = userResponse
        setUserCurrency(stripe_currency)

        const { data } = clubResponse
        let clubTheme = {}
        if (data.theme_temp) {
          try {
            clubTheme = JSON.parse(data.theme_temp) ?? {}
          } catch (error) {
            console.error('Error parsing JSON:', error)
          }
        }
        setTheme(clubTheme)
        setClub(data)
      } catch (err) {
        err.sentryEventId = Sentry.captureException(err)
        setError(err)
      } finally {
        setIsLoading(false)
      }
    }

    // noinspection JSIgnoredPromiseFromCall
    fetchData()
  }, [clubUuid])

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      {isLoading && <LoadingSpinner />}
      {!isLoading && !!error && <ErrorMessage error={error} />}
      {!isLoading && !error && (
        <>
          <Header
            clubTheme={theme}
            currentClub={club}
            isBillingPageActive
          />
          <ClubSubscriptionsContainer club={club} userCurrency={userCurrency} />
        </>
      )}
    </Box>
  )
}

ClubSubscriptionPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      clubUuid: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
}

export default ClubSubscriptionPage
